import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MenusRoutingModule } from './menus-route';
import { ManageMenusComponent } from './manage-menus/manage-menus.component';
import { MenuDialogComponent } from './Forms/menu-dialog/menu-dialog.component';


@NgModule({
  declarations: [
    ManageMenusComponent,
    MenuDialogComponent,

  ],
  imports: [
    CommonModule,
    MenusRoutingModule,
    SharedModule,

  ]
})
export class MenusModule { }
